import { render, staticRenderFns } from "./RegistrationInformation.vue?vue&type=template&id=7be2832a&scoped=true&"
import script from "./RegistrationInformation.vue?vue&type=script&lang=js&"
export * from "./RegistrationInformation.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationInformation.vue?vue&type=style&index=0&id=7be2832a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be2832a",
  null
  
)

export default component.exports